<template>
  <v-row>
    <v-col cols="12">
  <v-card
    class="pa-3"
    :class="
      $vuetify.breakpoint.smAndDown ? 'overflow-x-auto' : 'card-static-height'
    "
  >
    <header class="d-flex mb-2">
      <v-card-title class="body-1 flex-grow-0 flex-shrink-0">
        <span class="secondary--font font-weight-600">
          Tickets by Channel
        </span>
        <v-tooltip top max-width="350px" color="rgba(0, 0, 0, 0.7)">
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              size="20"
              class="pl-2 cursor-pointer"
              id="Tickets-by-channel"
              >mdi-information-outline</v-icon
            >
          </template>
          <span> The total tickets per source Channel. </span>
        </v-tooltip>
      </v-card-title>
      <div class="ml-auto flex-grow-0 flex-shrink-1">
        <v-select
          v-model="numberOfDays"
          :items="daysFilterData"
          placeholder="Select Filter"
          item-text="name"
          item-value="value"
          prepend-inner-icon="mdi-filter-variant"
          outlined
          dense
          short
          hide-details
          attach
          full-width
          class="filter-dropdown text-capitalize body-2 mt-3 mr-3"
          @change="getTicketByChannel()"
        />
      </div>
    </header>
    <v-card elevation="0">
      <div
        v-if="chartLoader"
        class="ticket-channel-chart d-flex justify-center"
      >
        <Bar
          :style="barStyles"
          :options="chartOptions"
          :chartdata="chartdata"
          :plugins="plugins"
        />
      </div>
      <div v-else class="ticket-channel-chart">
        <v-overlay
          :absolute="absolute"
          :z-index="zIndex"
          :value="(overlay = true)"
          opacity="0.2"
        >
        </v-overlay>
      </div>
    </v-card>
  </v-card>
    </v-col>
  </v-row>
</template>

<script>
/* chart data label plugin setting */
function chartDataLabelSetting(context, action) {
  const index = context.dataIndex;
  const data = context.dataset.data;
  const max = Math.max(...data);
  const percentil = 0.2;
  const value = data[index];
  if (action == "anchor") {
    return value <= max * percentil ? "top" : "end";
  } else if (action == "align") {
    return value <= max * percentil ? "top" : "start";
  } else {
    return value <= max * percentil ? context.dataset.backgroundColor : "white";
  }
}

import Bar from "@/components/charts/BarChart.vue";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { $dashboard } from "@/services/Index";
export default {
  components: {
    Bar,
  },
  data() {
    return {
      plugins: [ChartDataLabels],
      daysFilterData: [
        { name: "7 days", value: 7 },
        { name: "30 days", value: 30 },
        { name: "90 days", value: 90 },
      ],
      overlay: false,
      absolute: true,
      zIndex: 0,
      numberOfDays: 7,
      chartOptions: {},
      chartdata: {},
      chartRef: null,
      legendMarkup: null,
      chartLoader: false,
    };
  },

  computed: {
    barStyles() {
      let height = "240px";
      let width = "450px";
      let paddingTop = "20px";
      return {
        height,
        width,
        paddingTop,
      };
    },
  },

  mounted() {
    this.intializeGraph();
  },
  methods: {
    intializeGraph() {
      this.chartdata = {
        labels: [],
        datasets: [
          {
            lineTension: 0.3,
            label: "",
            maxBarThickness: 70,
            hidden: false,
            fill: false,
            data: [],
            backgroundColor: [],
            minBarLength: 5,
          },
        ],
      };
      this.chartOptions = {
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              var dataset =
                chart.config.data.datasets[tooltipItem.datasetIndex];
              return {
                backgroundColor: dataset.borderColor,
              };
            },
          },
        },

        plugins: {
          datalabels: {
            clamp: true,
            anchor: function (context) {
              return chartDataLabelSetting(context, "anchor");
            },
            align: function (context) {
              return chartDataLabelSetting(context, "align");
            },
            color: function (context) {
              return chartDataLabelSetting(context, "color");
            },
            display: function (context) {
              return context.dataset.data[context.dataIndex] >= 0;
            },
            offset: 6,
            font: {
              weight: 600,
              size: 30,
              family: "Montserrat",
            },
            formatter: Math.round,
          },
        },

        responsive: true,
        scaleBeginAtZero: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          padding: 20,
        },
        scales: {
          yAxes: [
            {
              display: false,
              gridLines: {
                drawOnChartArea: false,
                drawTicks: false,
              },
              ticks: {
                display: false,
                beginAtZero: true,
                fontColor: "black",
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
                drawTicks: false,
              },
              ticks: {
                callback: function (value) {
                  return value;
                },
                beginAtZero: true,
                fontColor: "black",
                fontSize: 16,
                fontWeight: 400,
                fontFamily: "Roboto",
                padding: 10,
              },
              position: "bottom",
            },
          ],
        },
      };
      this.getTicketByChannel();
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    /** get ticket by channel from API's */
    async getTicketByChannel() {
      this.chartLoader = false;
      let payload = {
        limit: this.numberOfDays,
      };

      try {
        const response = await $dashboard.ticketByChannel(payload, {});
        if (response.data) {
          this.setDataInGraph(response.data);
          this.chartLoader = true;
        }
      } catch (error) {
        console.log("error==", error);
        this.chartLoader = true;
      }
    },

    /** setting ticket By channel data in bar chart */
    setDataInGraph(data) {
      this.chartdata.labels = [];
      this.chartdata.datasets[0].data = [];
      this.chartdata.datasets[0].backgroundColor = [
        "rgba(232,138,58)",
        "rgba(100,102,209)",
        "rgba(237,59,86)",
      ];
      for (var key of Object.keys(data)) {
        if (key !== "webstore") {
          this.chartdata.datasets[0].data.push(data[key]);
          let label = this.capitalizeFirstLetter(key);
          this.chartdata.labels.push(label.replace("_", " "));
        }
      }
    },
  },
};
</script>

<style lang="scss">
.ticket-channel-chart {
  height: 230px !important;
}
.card-static-height {
  height: 330px;
}
</style>
